var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.resources,"size":"small","max-height":"700","highlight-row":"","stripe":""},scopedSlots:_vm._u([{key:"table_id",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.table ? row.table.table_no : '')+"\n    ")]}},{key:"invoice_no",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.invoice ? row.invoice.invoice_no : '')+"\n    ")]}},{key:"created_by",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.user ? row.user.name : '')+"\n    ")]}},{key:"floors",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.table ? row.table.floors : '')+"\n    ")]}},{key:"max_num_person",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.table ? row.table.max_num_person : '')+"\n    ")]}},{key:"deleted_by",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.deletedBy ? row.deletedBy.name : '')+"\n    ")]}},{key:"grand_total",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.invoice ? row.invoice.grand_total : '')+"\n    ")]}},{key:"order_no",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.invoice ? row.invoice.order_no : '')+"\n    ")]}},{key:"stock_out_date",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.invoice && row.invoice.stock_out_date
          ? _vm.formatDate(row.invoice.stock_out_date)
          : '')+"\n    ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }